<script setup lang="ts">
import { IconButton } from '@laam/ui/base';
import { PhCaretLeft } from '@phosphor-icons/vue';
import SearchButton from '~/components/SearchButton.vue';
import DeliveryOptions from './delivery-options/DeliveryOptions.vue';
import CartTrigger from './cart/CartTrigger.vue';

const setSelectedTab = inject('setSelectedTab') as (tab: string) => void;
const router = useRouter();
const emit = defineEmits<{
	(e: 'go-back'): void;
}>();
interface Prop {
	static?: boolean;
	showBack?: boolean;
	class?: string;
	showCart: boolean;
	selectedTabVal?: string;
	returnFromShippingEvent?: () => void;
	emitBackEventOnly?: boolean;
}

const backNav = () => {
	if (props.selectedTabVal) {
		setSelectedTab(props.selectedTabVal);
	}
	// nuxt3 router doesn't give any method to check navigation history, so we use window.history
	// to check if there is a history entry to go back to.
	// If there is no history entry, we redirect to the home page.
	if (window.history.length > 1) {
		router.go(-1);
	} else {
		router.push('/');
	}
};

const props = withDefaults(defineProps<Prop>(), {
	static: false,
	showBack: true,
	class: '',
	showCart: true,
	selectedTabVal: '',
	returnFromShippingEvent: () => {},
	emitBackEventOnly: false,
});
</script>
<template>
	<div
		class="py-md px-sm lg:py-3xl mobile_header flex items-center justify-between w-full bg-white border-b border-gray-200"
	>
		<div class="flex-1 flex items-center min-w-0">
			<slot name="leftIcon">
				<IconButton
					v-if="props.showBack"
					size="nav-button"
					variant="icon"
					@click="
						() => {
							props.returnFromShippingEvent && props.returnFromShippingEvent();
							if (props.emitBackEventOnly) {
								emit('go-back');
							} else {
								backNav();
							}
						}
					"
				>
					<PhCaretLeft />
				</IconButton>
			</slot>
			<div class="flex flex-col justify-center truncate min-w-0">
				<h1 class="text-md font-semibold text-gray-900">
					<slot name="title"></slot>
				</h1>
				<p class="line-clamp-1 lg:text-sm text-xs text-gray-600 capitalize">
					<slot name="subtitle"></slot>
				</p>
			</div>
		</div>
		<div class="gap-md lg:hidden flex">
			<slot name="actions">
				<DeliveryOptions />
				<SearchButton />
				<ClientOnly>
					<CartTrigger />
				</ClientOnly>
			</slot>
			<CartPopup v-if="showCart" />
		</div>
	</div>
</template>
